/**
 * AuthFlowLayout — sign-in / sign-up / onboarding shell: nav rail | centred
 * card | right banner. The rail behaves exactly as it does on the landing page
 * (member destinations greyed, opening the AuthGate prompt) and is dropped on
 * phones, where it would collapse into a tab bar over the form.
 *
 * It wears the signed-in shell's own classes so the three columns measure
 * exactly the same before and after login; `auth-flow` only adds the flat
 * surface and the vertically centred card.
 */
import type { PropsWithChildren } from 'react';
import { RightBanner } from './RightBanner';
import { SideNav } from './SideNav';
import './authFlow.css';

export function AuthFlowLayout({ children }: PropsWithChildren) {
  return (
    <div className="shell auth-flow">
      <SideNav />
      <main className="shell__content auth-flow__main">{children}</main>
      <RightBanner />
    </div>
  );
}
